<template>
    <div class="audio-gauge-container">
        <div class="audio-gauge-indicator-container">
            <span class="indicator first">0 <strong>-</strong></span>
            <span class="indicator second">-10 <strong>-</strong></span>
            <span class="indicator ">-20 <strong>-</strong></span>
            <span class="indicator ">-40 <strong>-</strong></span>
            <span class="indicator last">-60 <strong>-</strong></span>
        </div>
        <div 
            v-for="(item, index) in audio" 
            :key="index"
            
        >
            <multiple-channel
                v-if="item.channel_count > 1"
                :audio="item"
            ></multiple-channel>

            <mono-channel-level
                v-else
                :channel="item.channels[0]"
            ></mono-channel-level>
        </div>
    </div>
    
</template>

<script>
    import MultipleChannel from './multiple-channel.vue';
    import MonoChannelLevel from './mono-channel-level.vue';
    export default{
        name: 'PreviewAudio',
        components: {
            MultipleChannel,
            MonoChannelLevel,
        },
        props: {
            audio: {
                type: Array,
                required: true,
                default: [],
            },
        },
        data(){
            return{
            };
        },
        computed: {

        },
        methods: {

        }
    };
</script>
<style>
    .audio-gauge-container{
        position: absolute;
        background-color: white;
        display: flex;
        padding: 1rem;
        top: 0;
        right: 0;
        transform: translate(100%);
        padding-right: 4rem;
    }
    .audio-gauge-indicator-container{
        display: flex;
        flex-direction: column;
        padding-right: 1.5rem;
        width: 44px;
    }
    .indicator{
        text-align: right;
        margin-bottom: 3.2rem;
        font-size: 12px;
        
    }
    .first{
        margin-top: -3px;
        margin-bottom: 0.8rem;
    }
    .second{
        margin-top: 0;
        margin-bottom: 0.7rem;
    }
    .last{
        margin-top: -0.5rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/Preview/PreviewAudio/index.vue